import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { axiosInstance } from '../../api';
import { endpoints } from '../../api/endpoints';
import axios from 'axios';
import { useSelector } from 'react-redux';
import './ItemDetail.css';
import SellNft from '../../components/sellNft/SellNft';
import notify from '../../utils/notify';
import Loader from '../../components/loader/Loader';

const ItemDetails = () => {
    const paramData = useParams();
    const [nftDetails, setNftDetails] = useState(null);
    const [putOnSell, setPutOnSell] = useState(false);
    const [nftId, setNftId] = useState(null);
    const [ownerAddress, setOwnerAddress] = useState(null);
    const [nftAddress, setNftAddress] = useState(null);
    const [nftImage, setNftImage] = useState(null);
    const [nftAnimation, setNftAnimation] = useState(null);
    const [userId, setUserId] = useState(null);
    const [profileData, setProfileData] = useState(null);
    const [nftPrice, setNftPrice] = useState(0);
    const profileAddress = useSelector((state) => state.userData.userData?.address);
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();
    const userLoggedIn = useSelector((state) => state.auth.userLoggedIn);

    const addressRef = useRef();

    useEffect(() => {
        if (!userLoggedIn) {
            navigate('/auth');
        }
    }, [userLoggedIn, navigate]);

    useEffect(() => {
        const finalEndpoint = `${endpoints.getNft}?nftAddress=${paramData.nftAddress}&nftId=${paramData.nftId}`;
        setIsLoading(true);
        axiosInstance
            .get(finalEndpoint)
            .then((res) => {
                const ipfsHash = res.data.result.ipfsHash;
                setNftAddress(res.data.result.contractAddress);
                setPutOnSell(res.data.result.putOnSell);
                setOwnerAddress(res.data.result.ownerAddress);
                setNftId(res.data.result.tokenId);
                setUserId(res.data.result.userId);
                setNftPrice(res.data.result.nftPrice);
                setIsLoading(false);
                axios
                    .get(ipfsHash)
                    .then((res) => {
                        let imageSrc;
                        const prefix = res.data.image.split('//')[0];
                        if (prefix === 'ipfs:') {
                            imageSrc = `https://ipfs.io/ipfs/${res.data.image.split('//')[1]}`;
                        } else {
                            imageSrc = res.data.image;
                        }
                        setNftImage(imageSrc);

                        if (res.data.animation_url) {
                            let animationSrc;
                            const animPrefix = res.data.animation_url.split('//')[0];
                            if (animPrefix === 'ipfs:') {
                                animationSrc = `https://ipfs.io/ipfs/${res.data.animation_url.split('//')[1]}`;
                            } else {
                                animationSrc = res.data.animation_url;
                            }
                            setNftAnimation(animationSrc);
                        }
                        setNftDetails(res.data);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            })
            .catch((error) => console.error(error));
    }, [paramData]);

    useEffect(() => {
        if (userId) {
            axiosInstance
                .get(`${endpoints.getProfileById}?userId=${userId}`)
                .then((res) => {
                    setProfileData(res.data.result);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, [userId]);

    const cancelSellHandler = () => {
        axiosInstance
            .post(endpoints.cancelPutOnSell, paramData)
            .then((res) => {
                navigate(0);
            })
            .catch((error) => {
                console.error(error);
            });
    };
    const buyHandler = () => {
        const payload = {
            ...paramData,
            buyerAddress: profileAddress,
        };
        axiosInstance
            .post(endpoints.buyNft, payload)
            .then((res) => {
                navigate('/profile');
            })
            .catch((error) => {
                console.error(error);
                notify(error.response.data.Message);
            });
    };

    const copyHandler = () => {
        navigator.clipboard.writeText(addressRef.current.innerText);
        notify('Address copied!!!');
    };

    if (isLoading) {
        return <Loader />;
    }
    return (
        <div className="no-bottom no-top" id="content">
            {nftDetails && (
                <section aria-label="section" className="mt90 sm-mt-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 text-center item-detail-left">
                                {nftAnimation ? (
                                    <div className="detail-left-img">
                                        <video controls autoPlay muted loop>
                                            <source src={nftAnimation} />
                                        </video>
                                    </div>
                                ) : (
                                    nftImage && (
                                        <div className="detail-left-img">
                                            <img src={nftImage} className="img-fluid img-rounded mb-sm-30" alt="" />
                                        </div>
                                    )
                                )}
                            </div>
                            <div className="col-md-6">
                                <div className="item_info item-info-wrap">
                                    <h2>{nftDetails?.name ? nftDetails.name : '99 NFT'}</h2>
                                    <h4>#{nftId}</h4>
                                    <p style={{ display: 'flex' }}>
                                        Contract Address: &nbsp;
                                        <span className={'show-ellipsis'} style={{ float: 'none', display: 'inline-block' }} ref={addressRef}>
                                            {nftAddress}
                                        </span>
                                        <button style={{ position: 'static' }} type="button" id="btn_copy" title="Copy Text" onClick={copyHandler}>
                                            Copy
                                        </button>
                                    </p>
                                    {/* <div className="item_info_counts">
                                    <div className="item_info_type">
                                        <i className="fa fa-image"></i>Art
                                    </div>
                                    <div className="item_info_views">
                                        <i className="fa fa-eye"></i>250
                                    </div>
                                    <div className="item_info_like">
                                        <i className="fa fa-heart"></i>18
                                    </div>
                                </div> */}
                                    {nftDetails?.description && <p>{nftDetails?.description}</p>}
                                    <h6>Creator</h6>
                                    <div className="item-wrap item_author">
                                        <div className="author_list_pp">
                                            <Link to="/profile" className="profile-logo">
                                                {profileData?.profilePic && <img className="lazy" src={profileData?.profilePic} alt="" />}
                                                <i className="fa fa-check"></i>
                                            </Link>
                                        </div>
                                        <div className="author_list_info">
                                            {profileData?.name && (
                                                <Link to="/profile" className="text-capitalize">
                                                    {profileData?.name}
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                    <div className="item-btn-wrapper">
                                        {profileAddress?.toLowerCase() !== ownerAddress?.toLowerCase() ? (
                                            <>
                                                <p>Price: {nftPrice}ETH</p>
                                                <button onClick={buyHandler} type="button" className="btn-main">
                                                    Buy
                                                </button>
                                            </>
                                        ) : putOnSell ? (
                                            <button onClick={cancelSellHandler} type="button" className="btn-main">
                                                Cancel
                                            </button>
                                        ) : (
                                            <SellNft nftAddress={nftAddress} nftId={nftId} />
                                        )}
                                    </div>
                                    {/* <div className="spacer-40"></div>
                                <div className="de_tab tab_simple">
                                    <ul className="de_nav">
                                        <li className="active">
                                            <span>Trades</span>
                                        </li>
                                        <li>
                                            <span>History</span>
                                        </li>
                                    </ul>
                                    <div className="de_tab_content">
                                        <div className="tab-1">
                                            <div className="p_list">
                                                <div className="p_list_pp">
                                                    <Link to="/">
                                                        <img className="lazy" src={authorImage} alt="" />
                                                        <i className="fa fa-check"></i>
                                                    </Link>
                                                </div>
                                                <div className="p_list_info">
                                                    <b>0.005 ETH</b>
                                                    <span>
                                                        by <b>Mamie Barnett</b> at 6/14/2021, 5:40 AM
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="tab-2">
                                            <div className="p_list">
                                                <div className="p_list_pp">
                                                    <Link to="/">
                                                        <img className="lazy" src={authorImage} alt="" />
                                                        <i className="fa fa-check"></i>
                                                    </Link>
                                                </div>
                                                <div className="p_list_info">
                                                    <b>0.005 ETH</b>
                                                    <span>
                                                        by <b>Mamie Barnett</b> at 6/14/2021, 5:40 AM
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </div>
    );
};

export default ItemDetails;
